/* eslint-disable import/prefer-default-export */

const incorrectDateInterval = {
  message: 'The start or end date is incorrect!',
  description:
    'Selected date period is invalid for current brand. Please, check the date interval or select another brand.',
};

export { incorrectDateInterval };
